<template>
  <div>
    <div class="box box-success">
      <div class="box-header">
        <row style="text-align: center;">
          <h3 class="box-title dashboard-title">
            {{ $t("dashboard.hand_over") }}
          </h3>
        </row>
        <row style="text-align: center;">
          <div style="display: inline-block;">
            <div style="width:110px; margin-top:5px">
              <div class="input-group date">
                <date-picker
                  ref="periodPicker"
                  v-model="datePickerValue"
                  @dp-change="onHandleChangeMonth(datePickerValue)"
                  :config="optionsPicker"
                  :placeholder="$t('invoice.issuePeriod')"
                ></date-picker>
                <div class="input-group-addon" type="button" @click="$refs.periodPicker.dp.show()">
                  <i class="fa fa-caret-down"></i>
                </div>
              </div>
            </div>
          </div>
        </row>
      </div>
      <div class="box-body">
        <div class="chart"><LTEChart :chart-config="config"> </LTEChart></div>
      </div>
    </div>
  </div>
</template>

<script>
import LTEChart from "@/components/LTEChart";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import datePicker from "vue-bootstrap-datetimepicker";
import utils from '@/lib/utils'

export default {
  name: "ApartmentPerMonthPieChart",
  data() {
    return {
      datePickerValue: moment().format("YYYY/MM"),
      optionsPicker: {
        minDate: new Date(2019, 0),
        maxDate: moment(),
        format: "YYYY/MM",
        locale: this.$i18n.locale == "en" ? "en" : "vi"
      },
      config: {
        type: "pie",
        data: {
          labels: ["Căn Hộ Chưa Bàn Giao", "Căn Hộ Đã Bàn Giao"],
          datasets: [],
          dataValue: []
        },
        options: {
          responsive: true,
          legend: {
            display: true,
            position: "top",
            labels: {
              usePointStyle: true,
              generateLabels: function(chart) {
                var data = chart.data;
                if (data.labels.length && data.datasets.length) {
                  return data.labels.map(function(label, i) {
                    var meta = chart.getDatasetMeta(0);
                    var ds = data.datasets[0];
                    var arc = meta.data[i];
                    var custom = (arc && arc.custom) || {};
                    var getValueAtIndexOrDefault =
                      Chart.helpers.getValueAtIndexOrDefault;
                    var arcOpts = chart.options.elements.arc;
                    var fill = custom.backgroundColor
                      ? custom.backgroundColor
                      : getValueAtIndexOrDefault(
                          ds.backgroundColor,
                          i,
                          arcOpts.backgroundColor
                        );
                    var stroke = custom.borderColor
                      ? custom.borderColor
                      : getValueAtIndexOrDefault(
                          ds.borderColor,
                          i,
                          arcOpts.borderColor
                        );
                    var bw = custom.borderWidth
                      ? custom.borderWidth
                      : getValueAtIndexOrDefault(
                          ds.borderWidth,
                          i,
                          arcOpts.borderWidth
                        );

                    // We get the value of the current label
                    var value = chart.config.data.dataValue[i];

                    return {
                      // Instead of `text: label,`
                      // We add the value to the string
                      text: label + "  SL: " + value,
                      fillStyle: fill,
                      strokeStyle: stroke,
                      lineWidth: bw,
                      hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
                      index: i
                    };
                  });
                } else {
                  return [];
                }
              }
            }
          },
          tooltips: {
            mode: "index",
            intersect: false,
            callbacks: {
              label: function(tooltipItem, data) {
                let labels = data.labels;
                let currentLabel = labels[tooltipItem.index];
                let dataset = data.datasets[tooltipItem.datasetIndex];
                let currentValue = dataset.data[tooltipItem.index];
                let strLabel = `${currentLabel}: ${currentValue}%`;
                var sections = [];
                var words = strLabel.split(" ");
                var temp = "";
                words.forEach(function(item, index) {
                  if (temp.length > 0) {
                    var concat = temp + " " + item;
                    if (concat.length > 20) {
                      sections.push(temp);
                      temp = "";
                    } else {
                      if (index == words.length - 1) {
                        sections.push(concat);
                        return;
                      } else {
                        temp = concat;
                        return;
                      }
                    }
                  }
                  if (index == words.length - 1) {
                    sections.push(item);
                    return;
                  }
                  if (item.length < 20) {
                    temp = item;
                  } else {
                    sections.push(item);
                  }
                });
                return sections;
              }
            }
          },
          hover: {
            mode: "nearest",
            intersect: true
          }
        }
      }
    };
  },
  watch: {
    GET_LANG: function() {
      this.optionsPicker.locale = this.$i18n.locale == "en" ? "en" : "vi";
    }
  },
  computed: {
    ...mapGetters([
      "GET_LANG"
    ]),
    dateViewOptions: function() {
      return sessionStorage.getItem('projectDateViewOptions')
    }
  },
  methods: {
    ...mapActions([
      "GET_APARTMENT_HA_PER_REPORT"
    ]),
    onHandleChangeMonth: function(value) {
      this.renderChart();
    },
    renderChart: function() {
      const filter = {
        params: {
          ...utils.getAccountingPeriodFromDate(this.datePickerValue, "YYYY/MM")
        }
      };
      this.GET_APARTMENT_HA_PER_REPORT(filter).then(
        function(res) {
          let dataset = [];
          let dataValue = [];
          let datasets = [
            {
              backgroundColor: ["gray", "orange"],
              borderColor: ["gray", "orange"],
              data: []
            }
          ];
          let data = res;
          dataset[0] = data["not_handover_apartment_per"];
          dataset[1] = data["handover_apartment_per"];
          datasets[0].data = dataset;
          dataValue[0] = data["not_handover_apartment"];
          dataValue[1] = data["handover_apartment"];
          let clone_config = Object.assign({}, this.config);
          clone_config.data.datasets = datasets;
          clone_config.data.dataValue = dataValue;
          this.config = clone_config;
        }.bind(this)
      );
    }
  },
  components: {
    LTEChart,
    "date-picker": datePicker
  },
  mounted() {
    this.renderChart();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-box-content {
  margin-left: 0px;
  line-height: 35px;
}

.info-box-number {
  display: inline;
  font-size: 14px;
  padding: 12px;
}

.info-box-title {
  font-size: 25px;
  color: black !important;
  background: linear-gradient(
    to top,
    #9c9e9f 0%,
    #9c9e9f 50%,
    #adada7 50%,
    #ccc1c1 100%
  );
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/ApartmentPerMonthPieChart.vue